@layer reset, default, names, margin, size;

@layer reset {
  :host {
    display: inline-block;

    :host .gcds-icon {
      font-size: inherit;
      line-height: inherit;
      color: inherit;
    }
  }
}

@layer default {
  :host .gcds-icon {
    font-family: var(--gcds-icon-font-family) !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}

@layer names {
  :host .gcds-icon {
    &-checkmark-circle:before {
      content: "\e908";
    }

    &-chevron-down:before {
      content: "\e900";
    }

    &-chevron-left:before {
      content: "\e901";
    }

    &-chevron-right:before {
      content: "\e902";
    }

    &-chevron-up:before {
      content: "\e903";
    }

    &-close:before {
      content: "\e90b";
    }

    &-download:before {
      content: "\e906";
    }

    &-email:before {
      content: "\e905";
    }

    &-exclamation-circle:before {
      content: "\e909";
    }

    &-external:before {
      content: "\e904";
    }

    &-info-circle:before {
      content: "\e90a";
    }

    &-phone:before {
      content: "\e90c";
    }

    &-search:before {
      content: "\e907";
    }

    &-warning-triangle:before {
      content: "\e90d";
    }
  }
}

@layer margin {
  :host .gcds-icon {
    /* Margin left */
    &.ml-0 {
      margin-inline-start: var(--gcds-icon-margin-0);
    }

    &.ml-25 {
      margin-inline-start: var(--gcds-icon-margin-25);
    }

    &.ml-50 {
      margin-inline-start: var(--gcds-icon-margin-50);
    }

    &.ml-75 {
      margin-inline-start: var(--gcds-icon-margin-75);
    }

    &.ml-100 {
      margin-inline-start: var(--gcds-icon-margin-100);
    }

    &.ml-125 {
      margin-inline-start: var(--gcds-icon-margin-125);
    }

    &.ml-150 {
      margin-inline-start: var(--gcds-icon-margin-150);
    }

    &.ml-175 {
      margin-inline-start: var(--gcds-icon-margin-175);
    }

    &.ml-200 {
      margin-inline-start: var(--gcds-icon-margin-200);
    }

    &.ml-225 {
      margin-inline-start: var(--gcds-icon-margin-225);
    }

    &.ml-250 {
      margin-inline-start: var(--gcds-icon-margin-250);
    }

    &.ml-300 {
      margin-inline-start: var(--gcds-icon-margin-300);
    }

    &.ml-350 {
      margin-inline-start: var(--gcds-icon-margin-350);
    }

    &.ml-400 {
      margin-inline-start: var(--gcds-icon-margin-400);
    }

    &.ml-450 {
      margin-inline-start: var(--gcds-icon-margin-450);
    }

    &.ml-500 {
      margin-inline-start: var(--gcds-icon-margin-500);
    }

    &.ml-550 {
      margin-inline-start: var(--gcds-icon-margin-550);
    }

    &.ml-600 {
      margin-inline-start: var(--gcds-icon-margin-600);
    }

    &.ml-650 {
      margin-inline-start: var(--gcds-icon-margin-650);
    }

    &.ml-700 {
      margin-inline-start: var(--gcds-icon-margin-700);
    }

    &.ml-750 {
      margin-inline-start: var(--gcds-icon-margin-750);
    }

    &.ml-800 {
      margin-inline-start: var(--gcds-icon-margin-800);
    }

    &.ml-850 {
      margin-inline-start: var(--gcds-icon-margin-850);
    }

    &.ml-900 {
      margin-inline-start: var(--gcds-icon-margin-900);
    }

    &.ml-950 {
      margin-inline-start: var(--gcds-icon-margin-950);
    }

    &.ml-1000 {
      margin-inline-start: var(--gcds-icon-margin-1000);
    }

    &.ml-1050 {
      margin-inline-start: var(--gcds-icon-margin-1050);
    }

    &.ml-1100 {
      margin-inline-start: var(--gcds-icon-margin-1100);
    }

    &.ml-1150 {
      margin-inline-start: var(--gcds-icon-margin-1150);
    }

    &.ml-1200 {
      margin-inline-start: var(--gcds-icon-margin-1200);
    }

    &.ml-1250 {
      margin-inline-start: var(--gcds-icon-margin-1250);
    }

    /* Margin right */
    &.mr-0 {
      margin-inline-end: var(--gcds-icon-margin-0);
    }

    &.mr-25 {
      margin-inline-end: var(--gcds-icon-margin-25);
    }

    &.mr-50 {
      margin-inline-end: var(--gcds-icon-margin-50);
    }

    &.mr-75 {
      margin-inline-end: var(--gcds-icon-margin-75);
    }

    &.mr-100 {
      margin-inline-end: var(--gcds-icon-margin-100);
    }

    &.mr-125 {
      margin-inline-end: var(--gcds-icon-margin-125);
    }

    &.mr-150 {
      margin-inline-end: var(--gcds-icon-margin-150);
    }

    &.mr-175 {
      margin-inline-end: var(--gcds-icon-margin-175);
    }

    &.mr-200 {
      margin-inline-end: var(--gcds-icon-margin-200);
    }

    &.mr-225 {
      margin-inline-end: var(--gcds-icon-margin-225);
    }

    &.mr-250 {
      margin-inline-end: var(--gcds-icon-margin-250);
    }

    &.mr-300 {
      margin-inline-end: var(--gcds-icon-margin-300);
    }

    &.mr-350 {
      margin-inline-end: var(--gcds-icon-margin-350);
    }

    &.mr-400 {
      margin-inline-end: var(--gcds-icon-margin-400);
    }

    &.mr-450 {
      margin-inline-end: var(--gcds-icon-margin-450);
    }

    &.mr-500 {
      margin-inline-end: var(--gcds-icon-margin-500);
    }

    &.mr-550 {
      margin-inline-end: var(--gcds-icon-margin-550);
    }

    &.mr-600 {
      margin-inline-end: var(--gcds-icon-margin-600);
    }

    &.mr-650 {
      margin-inline-end: var(--gcds-icon-margin-650);
    }

    &.mr-700 {
      margin-inline-end: var(--gcds-icon-margin-700);
    }

    &.mr-750 {
      margin-inline-end: var(--gcds-icon-margin-750);
    }

    &.mr-800 {
      margin-inline-end: var(--gcds-icon-margin-800);
    }

    &.mr-850 {
      margin-inline-end: var(--gcds-icon-margin-850);
    }

    &.mr-900 {
      margin-inline-end: var(--gcds-icon-margin-900);
    }

    &.mr-950 {
      margin-inline-end: var(--gcds-icon-margin-950);
    }

    &.mr-1000 {
      margin-inline-end: var(--gcds-icon-margin-1000);
    }

    &.mr-1050 {
      margin-inline-end: var(--gcds-icon-margin-1050);
    }

    &.mr-1100 {
      margin-inline-end: var(--gcds-icon-margin-1100);
    }

    &.mr-1150 {
      margin-inline-end: var(--gcds-icon-margin-1150);
    }

    &.mr-1200 {
      margin-inline-end: var(--gcds-icon-margin-1200);
    }

    &.mr-1250 {
      margin-inline-end: var(--gcds-icon-margin-1250);
    }
  }
}

@layer size {
  :host .gcds-icon {
    &.size-text-small {
      font-size: var(--gcds-icon-font-size-text-small);
      line-height: var(--gcds-icon-line-height-text-small);

      @media only screen and (width < 48em) {
        font-size: var(--gcds-icon-font-size-text-small-mobile);
        line-height: var(--gcds-icon-line-height-text-small-mobile);
      }
    }

    &.size-text {
      font-size: var(--gcds-icon-font-size-text);
      line-height: var(--gcds-icon-line-height-text);

      @media only screen and (width < 48em) {
        font-size: var(--gcds-icon-font-size-text-mobile);
        line-height: var(--gcds-icon-line-height-text-mobile);
      }
    }

    &.size-h6 {
      font-size: var(--gcds-icon-font-size-h6);
      line-height: var(--gcds-icon-line-height-h6);

      @media only screen and (width < 48em) {
        font-size: var(--gcds-icon-font-size-h6-mobile);
        line-height: var(--gcds-icon-line-height-h6-mobile);
      }
    }

    &.size-h5 {
      font-size: var(--gcds-icon-font-size-h5);
      line-height: var(--gcds-icon-line-height-h5);

      @media only screen and (width < 48em) {
        font-size: var(--gcds-icon-font-size-h5-mobile);
        line-height: var(--gcds-icon-line-height-h5-mobile);
      }
    }

    &.size-h4 {
      font-size: var(--gcds-icon-font-size-h4);
      line-height: var(--gcds-icon-line-height-h4);

      @media only screen and (width < 48em) {
        font-size: var(--gcds-icon-font-size-h4-mobile);
        line-height: var(--gcds-icon-line-height-h4-mobile);
      }
    }

    &.size-h3 {
      font-size: var(--gcds-icon-font-size-h3);
      line-height: var(--gcds-icon-line-height-h3);

      @media only screen and (width < 48em) {
        font-size: var(--gcds-icon-font-size-h3-mobile);
        line-height: var(--gcds-icon-line-height-h3-mobile);
      }
    }

    &.size-h2 {
      font-size: var(--gcds-icon-font-size-h2);
      line-height: var(--gcds-icon-line-height-h2);

      @media only screen and (width < 48em) {
        font-size: var(--gcds-icon-font-size-h2-mobile);
        line-height: var(--gcds-icon-line-height-h2-mobile);
      }
    }

    &.size-h1 {
      font-size: var(--gcds-icon-font-size-h1);
      line-height: var(--gcds-icon-line-height-h1);

      @media only screen and (width < 48em) {
        font-size: var(--gcds-icon-font-size-h1-mobile);
        line-height: var(--gcds-icon-line-height-h1-mobile);
      }
    }
  }
}
